import React from "react"
import { graphql } from "gatsby"
import CaseStudyTemplate from "../../../components/caseStudies/CaseStudyTemplate"
import data from "../../../data/caseStudies/ecoZohm"

const EcoZohm = ({ data: queryData }) => (
  <CaseStudyTemplate
    {...data}
    heroImage={queryData.heroImage?.childImageSharp?.gatsbyImageData}
  />
)

export default EcoZohm

export const query = graphql`
  query EcoZohmCaseStudyImages {
    heroImage: file(relativePath: { eq: "caseStudies/ecoZohm-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
  }
`
